import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";







import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import ToolTip from "../common/ToolTip";
import usePermission from "../../usePermission";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";
;
;
;
;
;

export default function Toolbox(props: {
  displayComments: () => void;
  displayClientFilingTracking: () => void;
  displayAddClientFiling: () => void;
  displayAttachments: () => void;
}) {
  const navigate = useNavigate();
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const showCusotmerForm = () => {
    navigate("/customer");
  };

  const displayClientFilingTracking = () => {
    props.displayClientFilingTracking();
  };

  const displayAddClientFiling = () => {
    props.displayAddClientFiling();
  };

  const displayComments = () => {
    props.displayComments();
  };

  const displayAttachments = () => {
    props.displayAttachments();
  };

  const closeAlert = () => {
    setShowAlert(() => false);
  };

  return (
    <React.Fragment>
      <Box sx={{ 
        width: "100%", 
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton sx={{ justifyContent: "center", padding: "8px" }}>
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <GoogleMaterialIcon name="filter_list" color={primaryColor} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayAddClientFiling}
                disabled={!usePermission("ClientFilingList", "addFiling")}
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <ToolTip title="Add Deferred Filings">
                    <GoogleMaterialIcon name="person_add" color={primaryColor} />
                  </ToolTip>
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayClientFilingTracking}
                disabled={
                  !usePermission("ClientFilingList", "viewFilingTracking")
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="View Filing Tracking">
                  <GoogleMaterialIcon name="view_list" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayComments}
                disabled={!usePermission("ClientFilingList", "comments")}
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Comments">
                  <GoogleMaterialIcon name="comment" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>{" "}
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton onClick={displayAttachments} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Attachment">
                  <GoogleMaterialIcon name="attach_file" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
